const mixin = {
  methods: {
    setForm(settings) {
      const formKeys = Object.keys(this.form);
      settings.forEach(setting => {
        if (formKeys.includes(setting.key)) {
          let response = setting.response;
          if (response == 'f') {
            response = false;
          }
          if (response == 't') {
            response = true;
          }

          // hack, fix it later
          if (setting.key == 'overdue_notification_exclude_plans') {
            response = response ? JSON.parse(response) : [];
          }

          this.form[setting.key] = response;
        }
      });
    },

    getSettings() {
      return this.form;
    }
  }
};

export default mixin;
